import * as React from 'react';
import { Col, Input } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ApiBasedataList, BasedataEntryParams, BasedataParams } from '../../api';
import { CPItemWarning } from '../cpProfileComponent/CPItemWarning';
import { CPCourseItemEditComponent } from './CPCourseItemEditComponent';

export interface CPCourseBaseDataProps {
    baseDataName: string;
    baseDataKey: string;
    courseBaseDataArray: number[];
    className?: string;
    onChangeHandler: (baseDataIdArray: number[], baseDataName: string) => void;
}

export interface CPCourseBaseDataState {
    baseData: BasedataParams;
    baseDataIdArray: number[];
    checkedBoxs: boolean[];
    courseBaseData: BasedataParams;
    open: boolean;
}

export default class CPCourseBaseData extends React.PureComponent<CPCourseBaseDataProps, CPCourseBaseDataState> {
    constructor(props: CPCourseBaseDataProps) {
        super(props);
        this.state = {
            baseData: { Data: [], Key: '', Name: '' },
            baseDataIdArray: [],
            checkedBoxs: [],
            courseBaseData: { Data: [], Key: '', Name: '' },
            open: false,
        };
    }

    public componentDidMount() {
        const checkMe: boolean[] = [];
        const baseDataIdArrayMe: number[] = this.props.courseBaseDataArray;
        let myBaseData: BasedataParams = { Data: [], Key: '', Name: '' };
        let myBaseDataFromCourse: BasedataParams = { Data: [], Key: '', Name: '' };
        ApiBasedataList((sr) => {
            if (sr.OK && sr.Data) {
                sr.Data.Basedata.map((s: BasedataParams) => {
                    if (s.Key === this.props.baseDataKey) {
                        myBaseData = s;
                    }
                    myBaseDataFromCourse = { Data: [], Key: myBaseData.Key, Name: myBaseData.Name };
                    myBaseData.Data.sort(this.orderData).map((d: BasedataEntryParams, i: number) => {
                        checkMe.push(false);
                        baseDataIdArrayMe.map((n: number) => {
                            if (d.ID === n) {
                                myBaseDataFromCourse.Data.push(d);
                                checkMe[i] = true;
                            }
                        });
                    });
                });
                this.setState({
                    baseData: myBaseData,
                    baseDataIdArray: [...baseDataIdArrayMe],
                    checkedBoxs: [...checkMe],
                    courseBaseData: myBaseDataFromCourse,
                });
            }
        });
    }

    public render() {
        const baseDataContentEdit = this.state.baseData.Data.sort(this.orderData).map(this.renderContentEdit);

        const baseDataContent =
            this.state.courseBaseData && this.state.courseBaseData.Data.length > 0 ? (
                this.state.courseBaseData.Data.sort(this.orderData).map(this.renderContent)
            ) : (
                <Col className="mt-2">
                    <CPItemWarning errorMessage={TR.textAreaEditInput_missing_data} />
                </Col>
            );

        return (
            <CPCourseItemEditComponent
                name={this.props.baseDataName}
                onClickHandler={() => {
                    this.setState((prevState: CPCourseBaseDataState) => {
                        return { open: !prevState.open };
                    });
                }}
                content={baseDataContent}
                contentEdit={baseDataContentEdit}
                editState={this.state.open}
            />
        );
    }

    private renderContent = (data: BasedataEntryParams, index: number) => {
        return (
            <Col md={3} key={data.Content + (index + 1)}>
                {data.Content}
            </Col>
        );
    };

    private renderContentEdit = (data: BasedataEntryParams, index: number) => {
        return (
            <Col className="mb-2 mt-2" md={3} key={data.Content + (index + 1)}>
                <Input
                    className="mr-1"
                    id={`${this.props.baseDataKey}_checkbox${index}`}
                    name={`checkbox${index}`}
                    type="checkbox"
                    checked={this.state.checkedBoxs[index]}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const myBaseDataFromCourse: BasedataParams = {
                            Data: [],
                            Key: this.state.baseData.Key,
                            Name: this.state.baseData.Name,
                        };
                        const baseDataIdArrayMe: number[] = this.state.baseDataIdArray;
                        const checkMe: boolean[] = this.state.checkedBoxs;
                        checkMe[index] = e.target.checked;
                        if (checkMe[index]) {
                            if (baseDataIdArrayMe.indexOf(data.ID) < 0) {
                                baseDataIdArrayMe.push(data.ID);
                            }
                            this.state.baseData.Data.sort(this.orderData).map((d: BasedataEntryParams) => {
                                baseDataIdArrayMe.map((n: number) => {
                                    if (d.ID === n) {
                                        myBaseDataFromCourse.Data.push(d);
                                    }
                                });
                            });
                        } else {
                            if (baseDataIdArrayMe.indexOf(data.ID) > -1) {
                                baseDataIdArrayMe.splice(baseDataIdArrayMe.indexOf(data.ID), 1);
                                this.state.baseData.Data.sort(this.orderData).map((d: BasedataEntryParams) => {
                                    baseDataIdArrayMe.map((n: number) => {
                                        if (d.ID === n) {
                                            myBaseDataFromCourse.Data.push(d);
                                        }
                                    });
                                });
                            }
                        }
                        this.props.onChangeHandler(baseDataIdArrayMe, this.props.baseDataKey);
                        this.setState({
                            baseDataIdArray: [...baseDataIdArrayMe],
                            checkedBoxs: [...checkMe],
                            courseBaseData: myBaseDataFromCourse,
                        });
                    }}
                />
                <label htmlFor={`${this.props.baseDataKey}_checkbox${index}`}>{data.Content}</label>
            </Col>
        );
    };

    private orderData = (a: BasedataEntryParams, b: BasedataEntryParams) => {
        if (a.Content.toLocaleLowerCase() < b.Content.toLocaleLowerCase()) {
            return -1;
        } else if (a.Content.toLocaleLowerCase() > b.Content.toLocaleLowerCase()) {
            return 1;
        }
        return 0;
    };
}



// WEBPACK FOOTER //
// ./src/components/cpCoursesTableBox/CPCourseBaseData.tsx